import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import TitleSection from '../../../../common/TitleSection';
import styles from "../../../../ContentStyling.module.css";

const CmToKm = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertCmToKm = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in centimeters (e.g., 100000, 250000.5).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const cmValue = parseFloat(inputValue); // Convert input string to a number
        const kmValue = cmValue / 100000; // 1 km = 100,000 cm
        setOutputValue(kmValue.toFixed(6)); // Limit output to 6 decimal places
    };



      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/km-to-cm");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>CM to KM Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert Cm to KM using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
                      icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                      title="CM To KM Converter"
                      subTitle="Effortlessly Convert CM To KM for Accurate Measurements"
                    />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>CM Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter cm value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertCmToKm}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>KM Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>For students, scientists, engineers, and logistics professionals, the CM to KM Converter is an essential tool that simplifies the conversion from centimeters (CM) to kilometers (KM). Whether you're working on academic projects, large-scale mapping, or industrial measurements, this converter ensures quick, accurate, and reliable results. This tool bridges the gap between small and large-scale measurements, helping users shift between units with ease and precision.</p>
      <h3>What Are CM and KM?</h3>
      <p><b>Centimeters (CM): </b>A unit of length in the metric system. 1 cm = 0.01 meters. Commonly used for measuring small distances, objects, or body dimensions.</p>
      <p><b>Kilometers (KM): </b> A much larger metric unit. 1 kilometer = 1,000 meters or 100,000 centimeters. Frequently used for measuring long distances such as road lengths, geographic data, or race tracks.</p>
      <h3>Why Convert CM to KM?</h3>
      <ul>
        <li><b>Scalability:</b> Easily switch between micro and macro measurements in scientific or technical applications.</li>
        <li><b>Data Consistency:</b> Required when working with tools or software that demand inputs in kilometers.</li>
        <li><b>Simplified Representation:</b> Long values in centimeters can be simplified into kilometers for easier understanding and communication.</li>
      </ul>
      <h3>How to Use the CM to KM Converter</h3>
      <ol>
        <li><b>Input CM Value:</b> Enter the number of centimeters into the converter field.</li>
        <li><b>Click Convert:</b> The tool will instantly show the equivalent value in kilometers.</li>
        <li><b>Copy Result:</b> Use the converted KM value for your charts, maps, reports, or engineering diagrams.</li>
      </ol>
      <h3>Conversion Examples</h3>
      <ul>
        <li>1 cm → 0.00001 km</li>
        <li>10,000 cm → 0.1 km</li>
        <li>100,000 cm → 1 km</li>
        <li>250,000 cm → 2.5 km</li>
      </ul>
      <h3>Benefits of Using CM to KM Converter</h3>
      <ul>
        <li><b>Accurate & Instant:</b> Converts even large or complex values without manual calculation.</li>
        <li><b>Time-Saving:</b> Speeds up workflows for those working in mapping, surveying, or data processing.</li>
        <li><b>Simple Interface:</b> Easy enough for students, reliable enough for professionals.</li>
      </ul>
      <h3>Why Choose This CM to KM Converter?</h3>
      <p>Whether you're drafting a geographical survey, studying unit conversions in school, or working on transport infrastructure data, this tool is tailored to your needs. It’s especially valuable for:</p>
      <ul>
        <li><b>Researchers & Scientists:</b> For converting field data into standardized units.</li>
        <li><b>Geographers & Surveyors:</b> To handle measurements across vast landscapes.</li>
        <li><b>Students & Teachers:</b> For educational clarity and accurate problem-solving.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default CmToKm;
